import React from 'react';
import {
  Alert,
  AlertIcon,
  Box,
  Divider,
  Heading,
  Text,
  VStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { LEGAL, LEGAL_DISCLAIMER } from '../../config/legal';
import { LegalSection } from './legalContent';

interface LegalDocumentContentProps {
  title: string;
  sections: LegalSection[];
  showDisclaimer?: boolean;
  showTitle?: boolean;
  footer?: React.ReactNode;
}

const LegalDocumentContent: React.FC<LegalDocumentContentProps> = ({
  title,
  sections,
  showDisclaimer = true,
  showTitle = true,
  footer,
}) => {
  const muted = useColorModeValue('gray.600', 'gray.400');

  return (
    <VStack align="stretch" spacing={5}>
      {showTitle && (
        <Box>
          <Heading size="md" mb={1}>
            {title}
          </Heading>
          <Text color={muted} fontSize="sm">
            Last updated: {LEGAL.lastUpdated} · {LEGAL.companyName}
          </Text>
        </Box>
      )}

      {!showTitle && (
        <Text color={muted} fontSize="sm">
          Last updated: {LEGAL.lastUpdated} · {LEGAL.companyName}
        </Text>
      )}

      {showDisclaimer && (
        <Alert status="info" borderRadius="md">
          <AlertIcon />
          <Text fontSize="sm">{LEGAL_DISCLAIMER}</Text>
        </Alert>
      )}

      <VStack align="stretch" spacing={5} divider={<Divider />}>
        {sections.map((section) => (
          <Box key={section.id || section.title} id={section.id}>
            <Heading size="sm" mb={2}>
              {section.title}
            </Heading>
            <Box color={muted} fontSize="sm" lineHeight="tall">
              {section.content}
            </Box>
          </Box>
        ))}
      </VStack>

      {footer}

      <Text fontSize="sm" color={muted} textAlign="center" pt={2}>
        Questions? Contact{' '}
        <Text as="a" href={`mailto:${LEGAL.contactEmail}`} color="blue.500">
          {LEGAL.contactEmail}
        </Text>
      </Text>
    </VStack>
  );
};

export default LegalDocumentContent;
